<template>
<b-container fluid class="redefinir-senha-page">
    <div class="content">

      <div class="row d-flex justify-content-center align-items-center">
        <div class="col-lg-5 col-md-8 col-sm-12">
          <span>
            <form>

              <b-card header-bg-variant="primary" border-variant="primary" class="mb-0 pb-0">

                <template #header>
                  <h3 class="card-title text-center text-white">Redefinição de senha</h3>
                </template>

                <b-row class="m-0 p-0">
                  <div class="col-md-12">
                    <b-form-group class="mt-2"                  
                    label="Informe a nova Senha"
                    label-for="input-senha"      >
                    <b-form-input type="password" placeholder="Nova senha" id="input-senha" v-model="senha" trim></b-form-input>
                    </b-form-group>

                    <!-- Aviso das regras da senha (lado esquerdo) -->
                  <!-- Tooltip com as regras da senha -->
                  <b-tooltip
                    target="input-senha"
                    placement="left"
                    triggers="focus blur"                    
                    customClass="custom-tooltip"
                  >
                  &bull; A senha deve ter pelo menos 6 caracteres.<br />
                  &bull; Deve conter letras maiúsculas e minúsculas.<br />
                  &bull; Deve ter pelo menos um número e um caractere especial.
                  </b-tooltip>
                  </div>
                  <div class="col-md-12">
                    <b-form-group 
                    label="Confirmar senha"
                    label-for="input-conf-senha"      >
                    <b-form-input type="password" placeholder="Confirmar senha" id="input-conf-senha" v-model="confirmarSenha" trim></b-form-input>
                    </b-form-group>
                  </div>                  
                  
                </b-row>

                <b-row class="m-0 p-0">
                  <div class="col-md-12">
                    <div class="text-center mt-4">
                      <button type="submit" class="btn btn-info btn-fill" @click.prevent="confirmar">Confirmar</button>
                    </div>
                  </div>
                </b-row>

                <b-row class="px-3 pt-3">
                  <div class="col-md-12" v-if="errosRegra">
                    <b-alert show variant="danger">
                      <h6 class="alert-heading">Regras não atendidas</h6>
                      <hr>
                      <p class="mb-0">
                      <ul>
                        <li v-for="regra in errosRegra" :key="regra"> {{regra}} </li>
                      </ul>
                      </p>
                    </b-alert>
                  </div>
                </b-row>

              </b-card>
              <div class="clearfix"></div>
            </form>
          </span>
        </div>
      </div>
    </div>
  </b-container>
</template>
<script>
  import appUtils from '@/composables/utils';
import Card from 'src/components/Cards/Card.vue';
import AgendaService from "../../service/AgendaService";
  
  export default {
    components: {
      Card
    },
    data () {
      return {        
        senha: '',
        confirmarSenha: '',
        token: '',
        show: false,
        showFrom: "",
        filaShow: [], 
        errosRegra: null,
      }
    },
    mounted(){
      this.token = this.$route.params.token;
    },
    methods: {      
      confirmar () {

        const { toast, ativarShow, desativarShow } = appUtils(this)

        ativarShow("confirmar");

        this.errosRegra = null

        let dadosEnvio =
        { "senha": this.senha,
          "confirmarSenha": this.confirmarSenha,
          "token": this.token
        }

        AgendaService.resetarSenha(dadosEnvio)
          .then((resposta) => {            
          desativarShow("confirmar");
          let retorno = resposta.data;
            if (retorno.status === "SUCCESS") {
                        
            toast(retorno.mensagens[0].descricao, "Sucesso", "success");            

            toast('Logando no sistema', 'Autenticando', 'info')

            let user = {
              "username": retorno.obj.login,
              "password": this.senha,
              }

            this.senha = ''
            this.confirmarSenha = '';

            this.$store.dispatch('auth/login', user)
              .then((user) => {                
                var v = this
                setTimeout(function () {
                  v.$router.push({ name: 'Agenda' });
                }, 2000);
              },
                error => {
                  toast('Falha ao autenticar. Tente realizar o login novamente.', 'Falha', 'danger')
                }
              );          

          } else {

            desativarShow("alterarSenha");            
            if (retorno.mensagens.length > 0 && retorno.mensagens[0].descricao.startsWith("Falha regra")) {
              this.errosRegra = []
                retorno.mensagens.slice(1).forEach(element => {
                this.errosRegra.push(element.descricao)
              });
            } else {
              toast(retorno.mensagens[0].descricao, 'Falha', 'danger')              
            }
          }
        })
        .catch((err) => {
          this.showRegraSenha = false;
          desativarShow("confirmar");
          toast(err,"Falha","danger");
        });            
      }   
    }
  }

</script>
<style>

.redefinir-senha-page .card{
    border-radius: 10px;
    /*padding-top: 30px;*/
    padding-bottom: 30px;
  }

  .redefinir-senha-page .content{
    padding-top: 12vh;
  }

/* Estilizando o tooltip */
.custom-tooltip .tooltip-inner {
  background-color: #3f7bb7 !important; /* Cor de fundo amarelo */
  color: white !important; /* Cor do texto */
  /*font-weight: bold;*/
  font-size: 12px !important; /* ou o tamanho que desejar */
}

/* Alterando a cor da seta do tooltip */
.custom-tooltip.bs-tooltip-left .arrow::before {
  border-left-color: #3f7bb7 !important;
}
.custom-tooltip.bs-tooltip-right .arrow::before {
  border-right-color: #3f7bb7 !important;
}
.custom-tooltip.bs-tooltip-top .arrow::before {
  border-top-color: #3f7bb7 !important;
}
.custom-tooltip.bs-tooltip-bottom .arrow::before {
  border-bottom-color: #3f7bb7 !important;
}

</style>
